import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { ISalonReviewsItem } from '@app/shared/models';
import { ISeoTagType, SEOService } from '@app/shared/services';
import { inOutAnimation } from '@app/shared/utils';
import { IVisitReviewReplyForm } from '@app/visit-reviews/models';
import { VisitReviewsService } from '@app/visit-reviews/services';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-visit-review',
  templateUrl: './visit-review.component.html',
  styleUrls: ['./visit-review.component.scss'],
  animations: [inOutAnimation]
})
export class VisitReviewComponent implements OnInit {
  salonReviewsItem: ISalonReviewsItem;
  salonDetails: ISalonDetailsApi;
  reviewId: string;

  replyMode: boolean;
  replyToken: string;
  isReplyTokenValid: boolean;
  visitReviewReplyFormData: IVisitReviewReplyForm;
  formSubmitted: boolean;

  constructor(
    private route: ActivatedRoute,
    private visitReviewsService: VisitReviewsService,
    private seoService: SEOService
  ) { }

  ngOnInit(): void {
    const viewData: [ISalonReviewsItem, ISalonDetailsApi] = this.route.snapshot.data.viewData;
    const [salonReviewsItem, salonDetails] = viewData;
    this.salonReviewsItem = salonReviewsItem;
    this.salonDetails = salonDetails;
    this.reviewId = this.route.snapshot.paramMap.get('reviewId');

    this.replyMode = this.route.snapshot.url.some(x => x.path === 'reply');
    this.setSEO(this.replyMode);
    this.replyToken = this.route.snapshot.paramMap.get('reviewReplyToken');
    if (this.replyToken) {
      this.isReplyTokenValid = this.route.snapshot.data.reviewReplyTokenInfo.isReplyTokenValid;
      this.resetVisitReviewReplyFormData();
    }
  }

  replyFormSubmitted(): void {
    this.visitReviewsService.addReviewReply(this.reviewId, this.visitReviewReplyFormData)
      .subscribe(() => {
        this.formSubmitted = true;
        this.salonReviewsItem.salonReply = {
          createdOnUtc: new Date(),
          replyText: this.visitReviewReplyFormData.replyText
        };
        this.salonReviewsItem = cloneDeep(this.salonReviewsItem);
      });
  }

  private resetVisitReviewReplyFormData(): void {
    this.visitReviewReplyFormData = {
      replyToken: this.replyToken,
      replyText: '',
      areYouSureChecked: false
    };
  }

  private setSEO(replyMode: boolean): void {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: `VISIT-REVIEWS.${replyMode ? 'REPLY' : 'VIEW'}.META-TITLE`
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: `VISIT-REVIEWS.${replyMode ? 'REPLY' : 'VIEW'}.META-DESCRIPTION`
      }
    ]);
  }

}
